import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import TraceableConfigListing from './TraceableConfigListing'
import TraceableCredentialForm from './TraceableCredentialForm'

export default function TraceablePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={TraceableCredentialForm}
            PullConfigListingView={TraceableConfigListing}
        />
    )
}